import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <footer className=" bg-[#ffffff]">
        <section className="w-full pt-16 md:pt-[130px] -top-2/4 bg-[#ffffff] relative overflow-hidden">
          <div>
            <img
              src="./assets/images/home-two/shape-1.svg"
              alt="bg-shape"
              className="absolute bottom-20 moving-anim tran pointer-events-none"
            />
          </div>
          {/* animated circle bg  */}
          <div className="absolute -top-1 -left-1 flex justify-center items-center w-2 h-2 z-0 max-md:hidden">
            <div className="animated_circle bg-[#000000]/5" />
            <div className="animated_circle2 bg-[#000000]/5" />
            <div className="animated_circle3 bg-[#000000]/5" />
            <div className="animated_circle4 bg-[#000000]/5" />
          </div>
          {/* animated circle bg  */}

          <div className="theme-container mx-auto">
            <div className="w-full">
              <div className="top-bar w-full flex md:flex-row md:justify-between items-center flex-col space-y-10 md:space-y-0 md:mb-[80px] mb-10">
                <div>
                  <img
                    src="assets/images/brand_logo.png"
                    alt="Footer Logo"
                    style={{ width: "300px" }}
                  />
                </div>
              </div>
              <div className="w-full py-[80px] border-t border-[e7e3fa] grid xl:grid-cols-12 md:grid-cols-3 md:gap-10 grid-cols-2 gap-8 z-[99] max-[650px]:grid-cols-12">
                <div className="xl:col-span-4 max-md:col-span-12">
                  <div className="w-full mb-10">
                    <p className="text-main-black text-18 font-semibold mb-[30px]">
                      Address
                    </p>
                    <p className="font-medium text-paragraph">
                      C-171,Ground Floor Sector-63 Noida Uttar Pradesh 201301
                    </p>
                  </div>
                  <div className="w-full">
                    <p className="text-main-black text-18 font-semibold mb-[30px]">
                      Contact
                    </p>
                    <p className="font-medium text-paragraph">
                      <a
                        class="font-semibold cursor-pointer"
                        href="mailto:support@clickfordoctor.com"
                      >
                        support@clickfordoctor.com
                      </a>
                      <br />
                      <a
                        class="font-semibold cursor-pointer"
                        href="tel:919711300776"
                      >
                        +91-9211603304
                      </a>
                    </p>
                  </div>
                </div>
                <div className="xl:col-span-4  max-md:col-span-6">
                  <div className="w-full">
                    <p className="text-main-black text-18 font-semibold mb-[30px]">
                      Pages
                    </p>
                    <ul className="flex flex-col space-y-2.5">
                      <li className="common-transition text-paragraph font-medium">
                        <Link to="/"> Home </Link>
                      </li>
                      <li className="common-transition text-paragraph font-medium">
                        <Link to="/plans"> Plans </Link>
                      </li>
                      <li className="common-transition text-paragraph font-medium">
                        <Link to="/contact"> Contact Us </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="xl:col-span-4 max-md:col-span-6">
                  <div className="w-full">
                    <p className="text-main-black text-18 font-semibold mb-[30px]">
                      Quick Link
                    </p>
                    <ul className="flex flex-col space-y-2.5">
                      <li className="common-transition text-paragraph font-medium">
                        <Link to="/term-of-use"> Terms Of Use </Link>
                      </li>
                      <li className="common-transition text-paragraph font-medium">
                        <Link to="/shipping-delivery-policy">
                          Shipping & Delivery Policy
                        </Link>
                      </li>
                      <li className="common-transition text-paragraph font-medium">
                        <Link to="/privacy-policy"> Privacy Policy </Link>
                      </li>
                      <li className="common-transition text-paragraph font-medium">
                        <Link to="/cancellation-policy">
                          Canellation Policy
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              background: "linear-gradient(90deg, #f3f4f9 0%, #f3f4f9 63.23%)",
            }}
            className="w-full md:h-[65px]"
          >
            <div className="theme-container mx-auto h-full max-md:py-4">
              <div className="w-full h-full md:flex block justify-between items-center md:text-base">
                <span className="text-black">
                  2025 © All rights reserved by <b>ClickForDoctor</b>
                </span>
                <div className="relative md:block hidden">
                  <a
                    href="#"
                    aria-label="go top"
                    className="w-[45px] h-[45px] rounded-full border-[3px] border-white flex justify-center gototop items-center bg-theme-1 absolute -top-[75px] sm:-top-[55px] z-99"
                  >
                    <span>
                      <svg
                        width={45}
                        height={45}
                        viewBox="0 0 45 45"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="22.5"
                          cy="22.5"
                          r={21}
                          stroke="white"
                          strokeWidth={3}
                        />
                        <path
                          d="M19 21L23 17M23 17L27 21M23 17V29"
                          stroke="white"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </footer>
    </div>
  );
};

export default Footer;
